import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IFRAME_NAV_ITEMS } from '../../components/MetalsDashboardMain';
import './IframeDashboard.css';

/**
 * `MetalsDashboardMain.tsx` dagi "Batafsil" tugmasi shu BITTA komponentga
 * olib keladi (`/main/iframe/:key`) — sahifaning o'zi almashmaydi, faqat
 * tashqi dashboard manzilining `#<key>` qismi o'zgaradi:
 *
 *   Ishlab chiqarish bosilsa → .../?from=...&to=...#prod
 *   Elektr energiya bosilsa  → .../?from=...&to=...#energy
 *   ...va h.k.
 *
 * Yuqoridagi navbar band ro'yxati (`IFRAME_NAV_ITEMS`) `MetalsDashboardMain.tsx`
 * da e'lon qilingan — yangi bo'lim qo'shilganda faqat o'sha massivni
 * o'zgartirish kifoya, bu yerga tegilmaydi.
 */

/** Ishlab chiqaruvchi/host o'zgarsa — shu yerda yoki `.env` orqali almashtiriladi. */
const MONITOR_BASE = process.env.REACT_APP_MONITOR_BASE ?? 'https://tmk.bgs.uz/excel';

const pad2 = (n: number) => String(n).padStart(2, '0');
const isoDate = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

/** Joriy oyning 1-kunidan bugungi kungacha — misoldagi `from`/`to` bilan bir xil shaklda, lekin qotib qolmaydi. */
const defaultRange = () => {
    const today = new Date();
    const from = new Date(today.getFullYear(), today.getMonth(), 1);
    return { from: isoDate(from), to: isoDate(today) };
};

const IframeDashboard: React.FC = () => {
    const { key = '' } = useParams<{ key: string }>();
    const navigate = useNavigate();
    /* Menyular orasida almashish faqat `src`ning hash qismini o'zgartiradi —
       bu sahifani qayta yuklamaydi, shuning uchun `iframe.onLoad` faqat
       BIRINCHI marta ishga tushadi va `loaded` shu yerdan keyin true bo'lib
       qoladi (komponent o'zi qayta mount bo'lmaydi, chunki route bitta). */
    const [loaded, setLoaded] = useState(false);

    const isValidKey = IFRAME_NAV_ITEMS.some((item) => item.path === `/${key}`);
    const { from, to } = useMemo(defaultRange, []);

    const src = useMemo(
        () => `${MONITOR_BASE}/?from=${from}&to=${to}#${key}`,
        [from, to, key],
    );

    return (
        <div className="ifd-page">
            <nav className="ifd-nav">
                {IFRAME_NAV_ITEMS.map((item) => {
                    const itemKey = item.path.slice(1);
                    return (
                        <button
                            key={item.path}
                            type="button"
                            className={`ifd-nav-item${itemKey === key ? ' active' : ''}`}
                            onClick={() => navigate(`/main/iframe${item.path}`)}
                        >
                            {item.label}
                        </button>
                    );
                })}
            </nav>
            <div className="ifd-root">
                {!isValidKey ? (
                    <div className="ifd-empty">
                        <div className="ifd-empty-title">Bo'lim topilmadi</div>
                        <div className="ifd-empty-text">
                            "{key}" — navbar menyulariga mos kelmaydigan manzil. Yuqoridagi menyudan birini tanlang.
                        </div>
                    </div>
                ) : (
                    <>
                        {!loaded && (
                            <div className="ifd-loading">
                                <span className="ifd-spinner" />
                                <span className="ifd-loading-text">Yuklanmoqda…</span>
                            </div>
                        )}
                        <iframe
                            title={`monitor-${key}`}
                            src={src + "#token=" + (localStorage.getItem('tmk-token-bgs') || '')}
                            className="ifd-frame"
                            onLoad={() => setLoaded(true)}
                            allow="fullscreen"
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default IframeDashboard;
